import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { s as styleInject } from './style-inject.es-746bb8ed.js';
import classnames from 'classnames';
import Item from './toolbar/itemsList/Item.js';

var css_248z$1 = ".ZlO47{height:320px;overflow:auto;width:100%}.ZlO47.NII-I{height:calc(100vh - 230px)}";
var styles = {"container":"ZlO47","mobile":"NII-I"};
styleInject(css_248z$1);

var css_248z = ".VfRWg,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._8woEy{align-items:center;display:flex;flex-direction:column;height:320px;justify-content:center}.LFcgo,.o0c6G{color:var(--ricos-settings-text-color,#000);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:16px}[dir] .o0c6G{padding-top:4px}";
var generalStyles = {"fontElementMap":"VfRWg","emptyState":"_8woEy","title":"LFcgo","description":"o0c6G"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ItemsList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { selectedItem: {} };
  }
  render() {
    const { items, onClick, selectedItem, contentType, t, isMobile } = this.props;
    const emptyState = /* @__PURE__ */ React.createElement("div", { className: generalStyles.emptyState }, /* @__PURE__ */ React.createElement("div", { className: generalStyles.title }, t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Title`)), /* @__PURE__ */ React.createElement("div", { className: generalStyles.description }, t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Description`)));
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames(styles.container, { [styles.mobile]: isMobile }),
        "data-hook": "verticalsItemsList"
      },
      items.length > 0 ? items.map((item, index) => (
        // eslint-disable-next-line react/jsx-indent
        /* @__PURE__ */ React.createElement(
          Item,
          {
            item,
            key: index,
            onClick,
            selected: (selectedItem == null ? void 0 : selectedItem.id) === item.id,
            t
          }
        )
      )) : emptyState
    );
  }
}
__publicField(ItemsList, "propTypes", {
  items: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  contentType: PropTypes.string.isRequired,
  isMobile: PropTypes.boolean,
  t: PropTypes.func.isRequired
});

export { ItemsList as I, generalStyles as g };
//# sourceMappingURL=ItemsList-2febaa8a.js.map
